import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle } from 'lucide-react';
export function SalesLetter() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="py-16 px-4" data-id="element-145">
      <div className="max-w-3xl mx-auto" data-id="element-146">
        <motion.div {...fadeInUp} className="mb-12" data-id="element-147">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-dark mb-6" data-id="element-148">
            Seguro te pasó esto:
          </h2>

          <p className="text-lg text-dark/80 mb-4 leading-relaxed" data-id="element-149">
            Querés comer mejor, sentirte más liviana, bajar el consumo de azúcar
            o evitar el gluten…
          </p>

          <p className="text-lg text-dark/80 mb-6 leading-relaxed" data-id="element-150">
            pero terminás cayendo siempre en lo mismo.
          </p>

          <p className="text-lg text-dark/80 mb-4 leading-relaxed" data-id="element-151">
            Las recetas "saludables" que encontrás online suelen ser:
          </p>

          <ul className="space-y-2 mb-6" data-id="element-152">
            {['complicadas', 'caras', 'aburridas', 'con ingredientes difíciles de conseguir', 'o tan estrictas que duran solo unos días antes de que abandones'].map((item, i) => <li key={i} className="flex items-start gap-2 text-dark/70" data-id="element-153">
                <XCircle className="w-5 h-5 text-alert flex-shrink-0 mt-0.5" data-id="element-154" />
                <span data-id="element-155">{item}</span>
              </li>)}
          </ul>

          <p className="text-lg text-dark/80 mb-4 leading-relaxed font-semibold" data-id="element-156">
            Y mientras tanto seguís pensando:
          </p>

          <div className="bg-dark/5 p-6 rounded-lg mb-6 space-y-2 italic" data-id="element-157">
            <p data-id="element-158">"Comer sano no es para mí"</p>
            <p data-id="element-159">"No tengo tiempo"</p>
            <p data-id="element-160">"No sé qué preparar"</p>
            <p data-id="element-161">"Todo lo saludable sabe feo"</p>
            <p data-id="element-162">"Siempre termino picando cualquier cosa"</p>
          </div>

          <p className="text-xl text-dark font-semibold mb-2" data-id="element-163">
            La realidad es que el problema no sos vos.
          </p>

          <p className="text-lg text-dark/80 leading-relaxed" data-id="element-164">
            El problema es que nadie te enseñó una forma simple, rica y práctica
            de comer mejor sin sentir que estás a dieta.
          </p>
        </motion.div>

        <motion.div {...fadeInUp} className="mb-12 bg-alert/10 border-2 border-alert/20 rounded-2xl p-8" data-id="element-165">
          <h3 className="font-playfair text-2xl md:text-3xl font-bold text-dark mb-6" data-id="element-166">
            Si hoy sentís que:
          </h3>

          <ul className="space-y-3 mb-6" data-id="element-167">
            {['te cansaste de improvisar qué comer cada día', 'querés dejar el exceso de azúcar pero no sabés por dónde empezar', 'necesitás ideas rápidas para desayunos, meriendas, almuerzos, cenas y postres', 'querés opciones más livianas sin renunciar al sabor', 'buscás recetas fáciles incluso si no sos experta en la cocina', 'querés tener todo en un solo lugar, ordenado y listo para usar'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-168">
                <XCircle className="w-6 h-6 text-alert flex-shrink-0 mt-0.5" data-id="element-169" />
                <span className="text-dark/80" data-id="element-170">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl font-bold text-dark" data-id="element-171">
            Entonces este recetario fue hecho para vos.
          </p>
        </motion.div>

        <motion.div {...fadeInUp} className="mb-12 bg-primary/10 border-2 border-primary/20 rounded-2xl p-8" data-id="element-172">
          <h3 className="font-playfair text-2xl md:text-3xl font-bold text-dark mb-6" data-id="element-173">
            Con Recetario ZERO vas a tener una solución práctica, rica y lista
            para aplicar desde hoy:
          </h3>

          <ul className="space-y-3" data-id="element-174">
            {['+500 recetas digitales en un solo lugar', 'opciones sin azúcar y sin gluten', 'recetas fáciles de seguir paso a paso', 'ideas para todos los momentos del día', 'preparaciones rápidas y con ingredientes simples', 'acceso inmediato desde cualquier dispositivo', 'material descargable para consultar cuando quieras'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-175">
                <CheckCircle className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-176" />
                <span className="text-dark/80 font-medium" data-id="element-177">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div {...fadeInUp} className="bg-gradient-to-br from-accent/5 to-primary/5 rounded-2xl p-8" data-id="element-178">
          <div className="space-y-4 text-lg text-dark/80 leading-relaxed italic" data-id="element-179">
            <p data-id="element-180">
              Imaginate abrir tu celular y tener resuelto qué preparar sin
              perder tiempo buscando en Pinterest, YouTube o Google.
            </p>
            <p data-id="element-181">Imaginate comer rico sin sentir culpa.</p>
            <p data-id="element-182">
              Imaginate sorprenderte con postres, desayunos y comidas que
              realmente disfrutes.
            </p>
            <p data-id="element-183">
              Imaginate volver a tener variedad, orden y motivación en tu
              alimentación.
            </p>
            <p className="text-xl font-bold not-italic text-dark mt-6" data-id="element-184">
              Eso es exactamente lo que este recetario te ayuda a lograr.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}